import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SiteShell from "./components/site/SiteShell";
import AdminShell from "./components/admin/AdminShell";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/site/Home";
import Services from "./pages/site/Services";
import Book from "./pages/site/Book";
import Quote from "./pages/site/Quote";
import About from "./pages/site/About";
import Franchising from "./pages/site/Franchising";
import Commercial from "./pages/site/Commercial";
import Contact from "./pages/site/Contact";
import FAQ from "./pages/site/FAQ";
import NotFound from "./pages/site/NotFound";
import PaymentSuccess from "./pages/site/PaymentSuccess";
import PaymentCancel from "./pages/site/PaymentCancel";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import CalendarView from "./pages/admin/CalendarView";
import Contacts from "./pages/admin/Contacts";
import ContactDetail from "./pages/admin/ContactDetail";
import Pipeline from "./pages/admin/Pipeline";
import Jobs from "./pages/admin/Jobs";
import InboxPage from "./pages/admin/Inbox";
import Automations from "./pages/admin/Automations";
import Payments from "./pages/admin/Payments";
import SettingsPage from "./pages/admin/Settings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteShell />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/book" element={<Book />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/about" element={<About />} />
          <Route path="/franchising" element={<Franchising />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Navigate to="/login" replace />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="calendar" element={<CalendarView />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/:contactId" element={<ContactDetail />} />
          <Route path="pipeline" element={<Pipeline />} />
          <Route path="jobs" element={<Jobs />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="automations" element={<Automations />} />
          <Route path="payments" element={<Payments />} />
          <Route path="settings" element={<ProtectedRoute ownerOnly><SettingsPage /></ProtectedRoute>} />
        </Route>
        <Route element={<SiteShell />}>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
